import {useMutation, useQueryClient} from "@tanstack/react-query";
import {KNOWLEDGE_BASE_ENDPOINTS} from "../../services/network/endpoints";
import {KnowledgeBaseAPI} from "../../services/network/knowledgeBase-api";
import {toast} from "react-toastify";
import {IFileCreate} from "../../types/knowledgeBase.types";

interface UploadVideoParams {
    folderId: string;
    data: IFileCreate;
}

/**
 * Хук для загрузки видеофайлов в базу знаний
 * @returns Мутация для загрузки видео с превью
 */
export function useUploadKBVideo() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [KNOWLEDGE_BASE_ENDPOINTS.UPLOAD_VIDEO],
        mutationFn: async ({ folderId, data }: UploadVideoParams) => {
            // Убедимся, что тип установлен как 'video'
            const videoData: IFileCreate = {
                ...data,
                type: 'video'
            };
            
            return KnowledgeBaseAPI.uploadVideo(folderId, videoData);
        },

        onError() {
            toast.error("Ошибка при загрузке видео");
        },

        onSuccess: (_, variables) => {
            // Инвалидируем кэш для конкретной папки
            queryClient.invalidateQueries({
                queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDER_FILES, variables.folderId]
            });
            toast.success("Видео успешно загружено");
        }
    });
}